<template>
  <v-card class="auth-card pa-6" elevation="3" max-width="400" width="100%" rounded="lg">
    <v-card-title class="text-h6 font-weight-medium pa-0 mb-1">Вход в прайс</v-card-title>
    <v-card-subtitle class="pa-0 mb-4 text-medium-emphasis">
      Укажите учётные данные Bitrix
    </v-card-subtitle>
    <p v-if="userData.auth === false" class="font-weight-bold text-error mb-2">Ошибка авторизации</p>
    <v-form fast-fail @submit.prevent="authorize">
      <v-text-field
        v-model="login"
        density="compact"
        label="E-mail"
        autocomplete="username"
        prepend-inner-icon="mdi-email-outline"
        variant="outlined"
        hide-details="auto"
        class="mb-2"
      ></v-text-field>
      <v-text-field
        v-model="passwd"
        density="compact"
        label="Пароль"
        autocomplete="current-password"
        :append-inner-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
        :type="showPassword ? 'text' : 'password'"
        @click:append-inner="showPassword = !showPassword"
        variant="outlined"
        hide-details="auto"
        class="mb-4"
      ></v-text-field>
      <v-btn type="submit" block color="primary" size="large" :loading="isLoading">Войти</v-btn>
    </v-form>
  </v-card>
</template>

<script lang="ts">
export default { name: 'AuthForm' };
</script>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import axios from 'axios';
import { getApiBaseUrl } from '@/config/backendBaseUrl';
import { notifyErrorFromUnknown } from '@/utils/appNotify';

const store = useStore();

const login = ref('');
const passwd = ref('');
const showPassword = ref(false);
const isLoading = ref(false);

const userData = computed((): Record<string, unknown> => {
  const u = store.getters['user/userData'];
  if (u == null || (Array.isArray(u) && u.length === 0)) {
    return {};
  }
  return u as Record<string, unknown>;
});

async function authorize() {
  isLoading.value = true;
  try {
    const body = new URLSearchParams();
    body.set('login', login.value);
    body.set('passwd', passwd.value);
    const response = await axios.post(`${getApiBaseUrl()}/ajax/user/userAuthorize/`, body);
    localStorage.setItem('userData', JSON.stringify(response.data));
    store.commit('user/setUserData', response.data);
  } catch (e: unknown) {
    notifyErrorFromUnknown(e);
  } finally {
    isLoading.value = false;
  }
}
</script>
